import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFoundPage() {
  return (
    <>
      <Header />
      <main className="bg-white min-h-[60vh]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-36 pb-24 text-center">
          <h1 className="text-4xl sm:text-5xl font-light text-neutral-900 tracking-tight mb-6" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }} data-testid="notfound-h1">
            Página no encontrada
          </h1>
          <p className="text-neutral-500 font-light mb-10">La página que buscas no existe o fue movida.</p>
          <nav className="flex items-center justify-center gap-8 text-sm">
            <Link to="/" className="underline underline-offset-4 text-neutral-700 hover:text-amber-700" data-testid="notfound-link-inicio">Inicio</Link>
            <Link to="/proyectos" className="underline underline-offset-4 text-neutral-700 hover:text-amber-700" data-testid="notfound-link-proyectos">Proyectos</Link>
            <Link to="/contacto" className="underline underline-offset-4 text-neutral-700 hover:text-amber-700" data-testid="notfound-link-contacto">Contacto</Link>
          </nav>
        </div>
      </main>
      <Footer />
    </>
  );
}
